'use client';

import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface FAQ {
  question: string;
  answer: string;
}

interface FAQAccordionProps {
  faqs: FAQ[];
  practiceArea: string;
}

const FAQAccordion: React.FC<FAQAccordionProps> = ({ faqs, practiceArea }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="bg-white rounded-lg shadow-elevation-sm p-8">
      <div className="flex items-center mb-6">
        <Icon name="QuestionMarkCircleIcon" size={32} className="text-accent mr-4" />
        <h3 className="text-2xl font-serif font-semibold text-primary">
          Frequently Asked Questions - {practiceArea}
        </h3>
      </div>
      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="border border-border rounded-lg overflow-hidden transition-all duration-300 hover:border-accent"
          >
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full flex items-center justify-between p-5 text-left bg-surface hover:bg-accent/5 transition-colors duration-300"
            >
              <span className="font-semibold text-primary pr-4">{faq.question}</span>
              <Icon
                name="ChevronDownIcon"
                size={24}
                className={`text-accent flex-shrink-0 transition-transform duration-300 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}
              />
            </button>
            <div
              className={`overflow-hidden transition-all duration-300 ${
                openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
              }`}
            >
              <div className="p-5 bg-white border-t border-border">
                <p className="text-text-secondary leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQAccordion;